import _objectSpread from '@babel/runtime/helpers/objectSpread2';

/**
 * Create an action object
 * @param {String} type Name of Redux action
 * @param {*} payload action payload
 * @return {{ type: string, payload?: any }} flux action format object
 */
function createAction(type, payload) {
  return _objectSpread({
    type: type
  }, payload && {
    payload: payload
  });
}
export default createAction;